<p-table
  id="users-monitoring-table"
  [value]="usersData"
  [scrollable]="true"
  scrollDirection="horizontal"
  [tableStyle]="{ 'min-width': '50rem' }"
>
  <ng-template #header>
    <tr>
      <th
        class="!p-4"
        apeResponsiveFrozen
        style="min-width: 150px;"
      >
        <span class="font-bold text-[#020617]">
          {{ TRANSLATION_KEYS.admin.goalSettingMonitoring.table.COLLABORATOR | translate }}
        </span>
      </th>
      <th class="!p-4">
        <span class="font-bold text-[#020617]">
          {{ TRANSLATION_KEYS.admin.goalSettingMonitoring.table.MANAGER | translate }}
        </span>
      </th>
      <th class="!p-4">
        <span class="font-bold text-[#020617]">
          {{ TRANSLATION_KEYS.admin.goalSettingMonitoring.table.CARD_STATUS | translate }}
        </span>
      </th>
      <th class="!p-4">
        <span class="font-bold text-[#020617]">
          {{ TRANSLATION_KEYS.admin.goalSettingMonitoring.table.PROPOSAL_STATUS | translate }}
        </span>
      </th>
      <th class="!p-4">
        <span class="font-bold text-[#020617]">
          {{ TRANSLATION_KEYS.admin.goalSettingMonitoring.table.UPDATES | translate }}
        </span>
      </th>
      <th
        pFrozenColumn
        alignFrozen="right"
        class="relative text-center p-4 font-bold text-[var(--colors-gray-scale-black)]"
      >{{ TRANSLATION_KEYS.admin.goalSettingMonitoring.table.ACTIONS | translate }}</th>
    </tr>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-user
  >
    <tr>
      <td
        class="!px-4 !py-3.5"
        apeResponsiveFrozen
        style="min-width: 150px;"
      >
        <div class="flex flex-row items-center gap-[10px]">
          <ape-avatar
            [image]="user.avatarImage"
            [forename]="user.forename"
            [surname]="user.surname"
            size="medium"
            shape="square"
            [attr.aria-hidden]="true"
            [withRing]="false"
            [variant]="'simple'"
          />
          <span class="font-normal text-[#000]">
            {{ user.surname + " " + user.forename }}
          </span>
        </div>
      </td>
      <td class="!px-4 !py-3.5">
        <ng-container *ngIf="user.managerSurname; else noManager">
          {{ user.managerSurname }} {{ user.managerForename }}
        </ng-container>
        <ng-template #noManager>
          <span class="text-gray-400">—</span>
        </ng-template>
      </td>
      <td class="!px-4 !py-3.5">
        <ape-status-badge
          [aspect]="'fill'"
          [kind]="getStatusBadgeKind(user.cardStatus)"
          [label]="getCardStatusLabel(user.cardStatus)"
        />
      </td>
      <td class="!px-4 !py-3.5">
        <ape-status-badge
          [aspect]="'fill'"
          [kind]="getStatusBadgeKind(user.proposalStatus)"
          [label]="getProposalStatusLabel(user.proposalStatus)"
        />
      </td>
      <td class="!px-4 !py-3.5">
        <ng-container *ngIf="isUpdatesNd(user.updateStatus); else updatesNumeric">
          <span class="text-gray-500">{{ TRANSLATION_KEYS.admin.goalSettingMonitoring.table.ND | translate }}</span>
        </ng-container>
        <ng-template #updatesNumeric>
          <span class="font-semibold">{{ user.updateShareCount ?? 0 }}</span>
        </ng-template>
      </td>
      <td
        pFrozenColumn
        alignFrozen="right"
        class="relative !text-center"
      >
        <ape-button
          style="position: relative;"
          [id]="'action-user-button-' + user.userId"
          class="my-0 mx-auto !w-8 !h-8"
          [cssClass]="'!w-8 !h-8'"
          size="small"
          aspect="icon"
          variant="primary"
          [rightIcon]="'assets/icons/ellipsis.svg'"
          [ariaLabel]="TRANSLATION_KEYS.admin.goalSettingMonitoring.table.ACTIONS | translate"
          (buttonClick)="openMenu($event, user)"
          [disabled]="!user.canImpersonateUser && !user.canImpersonateManager && !user.canDownloadPdf && !user.canSolicitManager && !user.canSolicitUser"
        />
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="6" class="text-center text-gray-500 py-8">—</td>
    </tr>
  </ng-template>
</p-table>

<ape-menu [menuItems]="menuItems" #apeMenu />
